export default "__VITE_ASSET__Z$pMUUaP__"